import { Controller } from "@hotwired/stimulus"
import { emitContentMediaSelected } from "../utils/events"

export default class extends Controller {

  static values = {
    args: Object // arguments à renvoyer avec l'event pour l'identifier chez le récepteur
  }

  select(event) {
    console.log("il y a un event", event)
    const { id, action, ...file } = event.currentTarget.dataset;
    emitContentMediaSelected({ id, serialized_file: file }, this.argsValue);
    window.closeDialog('media_picker_modal');
  }

}
